import Toastify from "toastify-js";
import authorizedapp from "./authorizedapp";
import bugs from "./bugs";
import categories from "./categories";
import companies from "./companies";
import login from "./login";
import medias from "./medias";
import sharedcategories from "./sharedcategories";
import usercategories from "./usercategories";
import patchnotes from "./patchnotes";

export const URL_CORE: string = process.env.REACT_APP_URL_CORE || "https://qualif.winylo.fr";

export const URL_CORE_API: string = process.env.REACT_APP_HOST_CORE || "https://api.qualif.winylo.fr";

export const URL_HOST: string = process.env.REACT_APP_HOST_API || "https://api.ck-pture.qualif.c-koya.tech";

export const checkStatus = (res: Response): Response | Promise<never> => {
  if (res.ok) {
    return res;
  } else {
    if (res.status === 401) {
      window.location.href = "/login#redirect=" + window.location.pathname;
      return res.text().then((msg: string) => {
        throw new Error(msg);
      });
    } else {
      return res.json().then((data) => {
        let message = typeof data.message === "object" ? Object.values(data.message).join("\n") : data.message;
        Toastify({
          text: message,
          duration: message.length > 75 ? 8000 : 3000,
          close: true,
          gravity: "bottom", // `top` or `bottom`
          position: "right", // `left`, `center` or `right`
          backgroundColor: "linear-gradient(to right, #ff5f6d, #ffc371)",
        }).showToast();

        throw new Error(JSON.stringify(data));
      });
    }
  }
};

export const checkStatusQuiet = (res: Response): Response | Promise<never> => {
  if (res.ok) {
    return res;
  } else {
    return res.text().then((msg: string) => {
      throw new Error(msg);
    });
  }
};

export const parseFormData = (obj: { [key: string]: any }) => {
  let keys = Object.keys(obj);
  let bodyFormData = new FormData();

  keys.forEach((k) => {
    if (obj[k] === null) return;
    bodyFormData.set(k, obj[k]);
  });

  return bodyFormData;
};

const api = {
  loginApi: login,
  categories: categories,
  medias: medias,
  authorizedApp: authorizedapp,
  sharedCategories: sharedcategories,
  companies: companies,
  bugs: bugs,
  usercategories: usercategories,
  patchnotes,
};

export default api;
